module.exports = __webpack_public_path__ + "img/glutenfree.5fa5d192.jpeg";